<template>
  <div id="oie-options">
    <div id="toolbar-buttons">
      <div class="group group_crop">
        <div v-show="getEditor.cropMode" id="oieSliderConteiner">
          <div class="sliderZoom sliderZoomOut" @click="changeSlider(-5)">
            <appAwesomeIcon icon="image" useClass="fa fa-picture-o" />
          </div>
          <div id="oieSlider">
            <div id="oieSliderHandle" class="ui-slider-handle"></div>
          </div>
          <div class="sliderZoom sliderZoomIn" @click="changeSlider(+5)">
            <appAwesomeIcon icon="image" useClass="fa fa-picture-o" />
          </div>
          <div id="sliderText" v-html="getActiveSliderValue"></div>
        </div>
        <div
          v-show="getEditor.cropMode"
          id="t-cropMode"
          :class="{ 't-button': true }"
          @click="toggleCropMode(0)"
        >
          <div class="t-icon"></div>
        </div>
        <div
          v-show="!getEditor.cropMode"
          id="t-normalMode"
          :class="{ 't-button': true, style1: true }"
          @click="toggleCropMode(1)"
        >
          <div class="t-icon"></div>
        </div>
      </div>
      <div class="group">
        <div
          id="t-margins"
          :class="{ 't-button': true, active: getEditor.marginView }"
          @click="enableMarginView(true)"
        >
          <div class="t-icon"></div>
        </div>
        <div
          id="t-crop"
          :class="{
            't-button': true,
            style1: true,
            active: !getEditor.marginView
          }"
          @click="enableMarginView(false)"
        >
          <div class="t-icon"></div>
        </div>
      </div>
      <div class="group">
        <div
          id="t-portret"
          :class="{ 't-button': true, active: isPortret }"
          @click="doPortretToolbar"
        >
          <div class="t-icon"></div>
        </div>
        <div
          id="t-landscape"
          :class="{ 't-button': true, style1: true, active: isLandscape }"
          @click="doLandscapeToolbar"
        >
          <div class="t-icon"></div>
        </div>
      </div>
      <div v-if="0" class="group">
        <div id="t-rotate" class="t-button style1" @click="rotateImage()">
          <div class="t-icon"></div>
        </div>
      </div>
      <div class="group bck_group">
        <div
          id="change-background"
          :class="{ 't-button': true, style1: true, active: getEditor.bckMode }"
          @click="toggleBckMode()"
        >
          <appAwesomeIcon
            icon="file-image"
            useClass="fa fa-file-image-o t-icon"
          />
        </div>
      </div>
      <div class="group delete_group">
        <div
          id="delete-object"
          :class="{ 't-button': true, style1: true }"
          @click="deleteObjectHandler()"
        >
          <appAwesomeIcon icon="trash-alt" useClass="fa fa-trash-o t-icon" />
        </div>
      </div>
    </div>
    <div id="image-quality">
      <div class="label">
        {{ $t("Quality:") }}
      </div>
      <div :class="'quality-stars q' + getQuality"></div>
      <div class="quality-info info-button">
        <div class="qi-tooltip info-tooltip">
          <div class="qi-content info-content">
            <div class="qi-stars qi-5stars">
              {{ $t("Die allerbeste Qualität.") }}
            </div>
            <div class="qi-stars qi-4stars">
              {{ $t("Sehr gute Qualität.") }}
            </div>
            <div class="qi-stars qi-3stars">
              {{ $t("Akzeptabel aber vielleicht etwas unscharf.") }}
            </div>
            <div class="qi-stars qi-2stars">
              {{ $t("Nur mäßige Qualität.") }}
            </div>
            <div class="qi-stars qi-1stars">
              {{ $t("Ganz schlechte Qualität, unscharf und pixelig.") }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { useEditorFilesStore } from "@/stores/modules/editorFiles";
import { useImageEditorStore } from "@/stores/modules/imageEditor";
import { mapState, mapActions } from "pinia";

export default {
  computed: {
    ...mapState(useImageEditorStore, [
      "getFormat",
      "getActiveElement",
      "getPOIEVariables",
      "getReady",
      "getObject",
      "getEditor"
    ]),
    editor: function () {
      return this.getEditor;
    },
    format: function () {
      return this.getFormat;
    },
    formatType: function () {
      return this.format.width <= this.format.height;
    },
    isPortret: function () {
      return this.formatType;
    },
    isLandscape: function () {
      return !this.formatType;
    },
    getQuality: function () {
      if (this.getReady) {
        var POIEVariables = this.getPOIEVariables;
        var zoom = this.getEditor.zoom;
        var unit = (this.getEditor.dim.imageDimByFormat.unit / zoom) * 100;
        var inch_d = Math.sqrt(1 + 1);
        var px = unit / POIEVariables.cmToInch;
        var px_d = Math.sqrt(px * px + px * px);
        var ppi = px_d / inch_d;
        if (ppi < POIEVariables.ppiQuality[0]) return 1;
        if (ppi < POIEVariables.ppiQuality[1]) return 2;
        if (ppi < POIEVariables.ppiQuality[2]) return 3;
        if (ppi < POIEVariables.ppiQuality[3]) return 4;
        if (ppi < POIEVariables.ppiQuality[4]) return 5;
        if (ppi > POIEVariables.ppiQuality[4]) return 5;
        return 1;
      } else {
        return 1;
      }
    },
    getActiveSliderValue() {
      var activeElement = this.getActiveElement;
      var text = "";
      if (activeElement.type == "main") {
        text = this.getEditor.zoom;
      } else {
        if (activeElement.type == "object") {
          text = 100 + this.getObject.objects[activeElement.index].zoom * 10;
        }
      }
      return text + "%";
    }
  },
  methods: {
    ...mapActions(useImageEditorStore, [
      "doPortret",
      "doLandscape",
      "initEditor",
      "increaseRotateAngle",
      "changeMarginView",
      "deleteObject",
      "removeCutoutAction",
      "removeDosenAction",
      "changeCropModeAction",
      "changeBckMode",
      "changeZoom",
      "updateZoom"
    ]),
    doPortretToolbar: function () {
      this.doPortret({ widget: this });
    },
    doLandscapeToolbar: function () {
      this.doLandscape({ widget: this });
    },
    rotateImage: function () {
      if (this.getReady) {
        this.increaseRotateAngle();
        this.changeMarginView(0);
        this.initEditor();
      }
    },

    deleteObjectHandler: function () {
      var activeElement = this.getActiveElement;
      if (typeof activeElement != "undefined") {
        if (
          ["object", "steckdosen", "cutouts"].indexOf(activeElement.type) > -1
        ) {
          var item = this.getObject.objects[activeElement.index];
          if (typeof item != "undefined") {
            if (item.subtype == "cropimage") {
              this.deleteObject({
                index: activeElement.index
              });
            }
          }
          if (activeElement.type == "cutouts") {
            this.removeCutoutAction({
              index: activeElement.index
            });
          }
          if (activeElement.type == "steckdosen") {
            this.removeDosenAction({
              index: activeElement.index
            });
          }
        }
      }
    },
    enableMarginView: function (flag) {
      this.changeMarginView(flag);
    },
    toggleCropMode: function (flag) {
      jQuery("body").removeClass("active");
      if (flag) {
        jQuery("body").addClass("active");
      }
      this.changeCropModeAction(flag);
    },
    toggleBckMode: function () {
      this.changeBckMode(!this.getEditor.bckMode | 0);
    },
    changeSlider: function (value) {
      var slider = jQuery("#oieSlider");
      var oldVal = slider.slider("value");
      var newVal = oldVal + value;

      if (newVal < 100) newVal = 100;
      if (newVal > 150) newVal = 150;
      slider.slider("value", newVal);
    }
  },
  mounted: function () {
    jQuery("#oieSlider").slider({
      min: 100,
      max: 150,
      value: 1,
      create: (function (that) {
        return function () {
          that.changeZoom(jQuery(this).slider("value"));
        };
      })(this),
      slide: (function (that) {
        return function (event, ui) {
          var activeElement = that.getActiveElement;
          if (activeElement.type == "main") {
            that.changeZoom(ui.value);
          } else {
            that.updateZoom({
              index: activeElement.index,
              zoom: (ui.value % 100) / 10
            });
          }
        };
      })(this),
      stop: (function (that) {
        return function (event, ui) {
          var activeElement = that.getActiveElement;
          if (activeElement.type == "main") {
            that.changeZoom(ui.value);
          } else {
            that.updateZoom({
              index: activeElement.index,
              zoom: (ui.value % 100) / 10
            });
          }
        };
      })(this),
      change: (function (that) {
        return function (event, ui) {
          var activeElement = that.getActiveElement;
          if (activeElement.type == "main") {
            that.changeZoom(ui.value);
          } else {
            that.updateZoom({
              index: activeElement.index,
              zoom: (ui.value % 100) / 10
            });
          }
        };
      })(this)
    });
  }
};
</script>
